import type { Configuration } from '@repo/api-gw-sdk';

import { accountLogo } from './accountLogo';
import { aiAgents } from './aiAgents';
import { apiCredentials } from './apiCredentials';
import { auditLogs } from './auditLog';
import { azure } from './azure';
import { backupPolicy } from './backupPolicy';
import { cloudAccounts } from './cloudAccounts';
import { controls } from './controls';
import { convert } from './convert';
import { dashboards } from './dashboards';
import { db } from './db';
import { discovery } from './discovery';
import { explorer } from './explorer';
import type { HttpClient } from './httpClient';
import { idpGroups } from './idpGroups';
import { integrations } from './integrations';
import { inventory } from './inventory';
import { jobs } from './jobs';
import { lakehouse } from './lakehouse';
import { limits } from './limits';
import { logs } from './logs';
import { metering } from './metering';
import { mongoAtlasPrivateLinks } from './mongoAtlasPrivateLinks';
import { notifications } from './notifications';
import { objectStoreExclusionRules } from './objectStoreExclusionRules';
import { preferences } from './preferences';
import { projects } from './projects';
import { restore } from './restore';
import { roles } from './roles';
import { saml } from './saml';
import { search } from './search';
import { security } from './security';
import { storageGateway } from './storageGateway';
import { users } from './users';
import { vaults } from './vaults';

export const projectDalFactory = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => ({
  inventory: inventory(httpClient, config, currentProjectId),
  logs: logs(httpClient, config, currentProjectId),
  discovery: discovery(httpClient, config, currentProjectId),
  explorer: explorer(httpClient, config, currentProjectId),
  search: search(httpClient, config, currentProjectId),
  backupPolicy: backupPolicy(httpClient, config, currentProjectId),
  jobs: jobs(httpClient, config, currentProjectId),
  restore: restore(httpClient, config, currentProjectId),
  vaults: vaults(httpClient, config, currentProjectId),
  convert: convert(httpClient, config, currentProjectId),
  db: db(httpClient, config, currentProjectId),
  dashboards: dashboards(httpClient, config, currentProjectId),
  controls: controls(httpClient, config, currentProjectId),
  cloudAccounts: cloudAccounts(httpClient, config, currentProjectId),
  mongoAtlasPrivateLinks: mongoAtlasPrivateLinks(
    httpClient,
    config,
    currentProjectId
  ),
  azure: azure(httpClient, config, currentProjectId),
  notifications: notifications(httpClient, config, currentProjectId),
  integrations: integrations(httpClient, config, currentProjectId),
  security: security(httpClient, config, currentProjectId),
  storageGateway: storageGateway(httpClient, config, currentProjectId),
  lakehouse: lakehouse(httpClient, config, currentProjectId),
  limits: limits(httpClient, config, currentProjectId),
  objectStoreExclusionRules: objectStoreExclusionRules(
    httpClient,
    config,
    currentProjectId
  ),
  metering: metering(httpClient, config),
});

export const nonProjectDalFactory = (
  httpClient: HttpClient,
  config: Configuration,
  isDevOrTest: boolean
) => ({
  auditLogs: auditLogs(httpClient, config),
  projects: projects(httpClient, config),
  users: users(httpClient, config, isDevOrTest),
  preferences: preferences(httpClient, config),
  saml: saml(httpClient, config),
  idpGroups: idpGroups(httpClient, config),
  roles: roles(httpClient, config),
  apiCredentials: apiCredentials(httpClient, config, isDevOrTest),
  aiAgents: aiAgents(httpClient, config),
  accountLogo: accountLogo(httpClient, config),
});
